import React from 'react'

class Intro extends React.Component {
  render() {
    return (
      <div className="container mb-md">
        <h1 className="page-title">
          BOWL
          <span className="color-red">OF</span>
          CODE
        </h1>
        <p>
          Thoughts and rants on software development, leadership and working remotely.
          <br/>
          <small>by <a href="mailto:hello@oskar.io">Oskar Zabik</a></small>
        </p>
      </div>
    )
  }
}

export default Intro



// WEBPACK FOOTER //
// ./src/components/Intro.js